import { useEffect, useReducer } from 'react'
import DocumentsManager from '../managers/documents'

import {
  logger
} from '../utils'

import {
  DOCUMENTS_STATE_UPDATE
} from '../actions'

const initialState = {
  documentTypes: [],
  documents: [],
  loading: false,
  error: null
}

const documentsReducer = (state, action) => {
  switch (action.type) {
    case DOCUMENTS_STATE_UPDATE: {
      const { payload } = action

      return {
        ...state,
        ...payload
      }
    }
    default:
      return state
  }
}

export const useDocumentsState = () => {
  const [state, dispatch] = useReducer(documentsReducer, initialState)

  useEffect(() => {
    function handleActionDispatch (action) {
      logger.debug('[documents dataprovider]', 'action', action)
      return dispatch(action)
    }

    DocumentsManager.subscribeToActions(handleActionDispatch)

    return () => {
      DocumentsManager.unsubscribeFromActions(handleActionDispatch)
    }
  })

  return state
}
